import React, { Component } from 'react';
import Select from 'react-select';

import services from './data';

let CategoryOptions;

class VendorList extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      options: [],
    };
  }
  componentDidMount() {
    services
      .getVendorList()
      .then((response) => {
        const tmp = response.data.data.results;
        CategoryOptions = [];
        for (let i = 0; i < tmp.length; i++) {
          CategoryOptions.push({
            value: tmp[i].uuid,
            label: `${tmp[i].first_name} ${tmp[i].last_name}`,
          });
        }
        this.setState({ options: CategoryOptions });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  handleChange = (selectedOption) => {
    const id = this.props.did ? this.props.did : 0;
    let option = selectedOption;
    if (selectedOption == null) {
      option = { value: '', label: '' };
    }
    this.props.onChange(option, id);
  };

  render() {
    const { options } = this.state;
    return (
      <Select
        onChange={this.handleChange}
        isClearable={true}
        options={options}
        className="select-box-container vendor-selector-container"
        classNamePrefix="vendor-selector"
        name="vendor"
        placeholder="Select vendor"
        value={options.filter(({ value }) => value === this.props.value)}
        isDisabled={this.props.disabled || false}
      />
    );
  }
}

export { VendorList };
